import {
  getGoalArchetype,
  goalsFromArchetype,
  isGoalArchetypeId,
} from '../data/goalArchetypes';
import type { GoalArchetypeId, UserGoals } from '../types';

export { getGoalArchetype, goalsFromArchetype, isGoalArchetypeId };

export function defaultGoals(
  id: GoalArchetypeId = 'hverdagstastatur',
): UserGoals {
  return goalsFromArchetype(id);
}

export function suggestArchetypeFromBaseline(wpm: number): GoalArchetypeId {
  if (wpm < 30) return 'rolig-skriver';
  if (wpm < 45) return 'hverdagstastatur';
  if (wpm < 58) return 'arbejdsrytme';
  if (wpm < 72) return 'fokusflow';
  return 'touch-virtuos';
}

export function normalizeUserGoals(goals: UserGoals | undefined): UserGoals {
  if (!goals || !isGoalArchetypeId(goals.archetypeId)) {
    return defaultGoals();
  }
  const base = goalsFromArchetype(goals.archetypeId);
  return {
    archetypeId: goals.archetypeId,
    targetWpm: clampFinite(goals.targetWpm, 15, 120, base.targetWpm),
    targetAccuracy: clampFinite(
      goals.targetAccuracy,
      0.8,
      1,
      base.targetAccuracy,
    ),
    targetCurriculumProgress: clampFinite(
      goals.targetCurriculumProgress,
      0.1,
      1,
      base.targetCurriculumProgress,
    ),
  };
}

function clampFinite(
  value: number,
  min: number,
  max: number,
  fallback: number,
): number {
  if (!Number.isFinite(value)) return fallback;
  return Math.max(min, Math.min(max, value));
}
